import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Camera, IsClosed, IsOpen, Left, Plus, Times, View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { HBox, VBox } from '../../../../components/Box';
import { Row, Cell } from '../../../../components/List';
import { selectAllOptions, selectVehicle } from '../../../Vehicles/selectors';
import { Checkbox } from '../../../../components/Checkbox';
import { addVehicleOption, deleteVehicleProperty, removeVehicleOption, setVehicleProperty } from '../../../Vehicles/actions';
import { ButtonBar } from '../../../../components/ButtonBar';
import _ from 'lodash';
import { COLOR_PRIMARY_1, COLOR_SECONDARY_1 } from '../../../../vars';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { addDocument, deleteDocument } from '../../../Documents/actions';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import { parseISO } from 'date-fns';
import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';

import { Cell as ActionCell } from '../Cell';
import { resizeAndRotate } from '../../../../utils/image';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import cn from 'classnames';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import CheckboxComponent from '../../../../containers/App/Components/Checkbox/Checkbox';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './HOOI.module.css';
import { isMobileDevice } from '../../../../utils/checkDevice';

const Container = styled.div`
  .modal-inner {
  }

  .option {
    &.inactive {
      opacity: 0.5;
    }
  }

  .pane {
    padding: 12px 0;
    border-bottom: 1px solid #eee;
    width: 100%;
    margin-bottom: 12px;
    border-bottom: none;

    .title {
      text-transform: uppercase;
    }
    h1 {
      font-size: 18px;
    }
  }

  .optionPhoto {
    position: fixed;
    background-color: black;

    .img {
      position: absolute;
      top: 90px;
      left: 10px;
      right: 10px;
      bottom: 10px;
      background-size: contain;
      background-position: center center;
    }
  }
  .options-list {
    .title {
      font-weight: 600;
      margin-top: 12px;
      font-size: 1.2rem;
      border-bottom: 1px solid #ddd;
      width: 100%;
      margin-bottom: 3px;
    }
  }
  .image-available {
    width: 32px;
    height: 32px;
    background-color: ${COLOR_SECONDARY_1};
    color: white;
    border-radius: 15px;
    text-align: center;
    margin-right: 3px;
    padding-top: 1px;

    .icon {
      margin: 0;
      padding: 0 0;
    }
  }

  .manco-list > div {
    margin: 12px 0;
  }

  .triple {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 12px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      width: 24px;
      height: 24px;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      display: flex;
      align-items: stretch;
      justify-content: center;
      background-color: #0183d5;
      color: var(--color-new-white);
      border-radius: 0.375rem;
    }

    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        background-color: var(--color-new-secondary);
      }
    }
    &.triple-2 {
      .check {
        background-color: #fa5c7c;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
    @media (max-width: 425px) {
      font-size: 12px;
    }
  }

  .tire_set {
    /* padding: 12px;
    background-color: #eee; */

    > .box {
      max-width: 330px;
    }
    .tire-depth-container {
      width: 100%;
      .button {
        width: 60px;
        margin: 1px;
        align-self: stretch;
      }
    }

    .vehicle-property-loadable {
      max-width: 300px;
      &.loading {
        opacity: 0.2;
      }
    }
  }

  .hooi_instalation-img {
    width: 100px;
    height: 100px;
    flex-shrink: 0;
    background-size: contain;
    border: 1px solid black;
    background-position: center center;
    .add {
      width: 100px;
      height: 100px;
    }
  }
`;

const STATE = {
  approve: false,
  options: false,
  manco: false,
  hooi_instalation: false,
  regplate_code: '',
  date_last_maintenance: '',
  mileage_last_maintenance: '',
  date_timing_belt_change: '',
  mileage_timing_belt_change: '',
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_inslagComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    const comments = this.vehicle?.properties
      ?.filter(p => p?.propertyName?.name?.startsWith('hooi_instalation_comment_'))
      ?.reduce(
        (acc, prop) => ({
          ...acc,
          [prop?.propertyName?.name]: prop?.propertyValue?.value,
        }),
        {},
      );
    this.setState({ ...comments });
  }

  reset() {
    this.setState({ ...STATE });
  }

  static getDerivedStateFromProps(props, state) {
    ['date_last_maintenance', 'mileage_last_maintenance', 'mileage_timing_belt_change'].map(name => {
      let val = props.cell?.vehicle[name];
      if (val) {
        if (val.updatedAt != state[name + '_updatedAt']) {
          state[name + '_updatedAt'] = val.updatedAt;
          state[name] = val.propertyValue.value;
        }
      } else {
      }
    });
    return state;
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.vehicle[name];
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  capture(name, callback) {
    //remove existing image upload
    document.getElementById('image-upload')?.remove();

    let input = document.createElement('input');
    input.type = 'file';
    input.name = 'image';
    input.id = 'image-upload';
    input.accept = 'image/*';
    // input.setAttribute('capture', 'camera');

    if (isMobileDevice()) {
      input.setAttribute('capture', 'environment');
    }

    document.body.appendChild(input);

    input.click();

    input.addEventListener(
      'change',
      this.callback(evt => {
        resizeAndRotate(evt.target.files[0]).then(file => {
          this.props.imageUpload(
            {
              name,
              type: 'photo_hooi_' + name,
              originalFilename: 'originalFilename',
              file,
            },
            'upload_' + name,
          );

          callback?.();

          try {
            evt.target.removeEventListener(evt.target, this._evtListener);
            evt.target.remove();
          } catch (e) {}
        });
      }),
    );
  }

  toggleOption(id, state) {
    this._lastOption = id;

    //todo: busy_ ... is depricated
    this.setState(
      { [`busy_${id}`]: true },
      this.props.toggleOption(id, state, result => {
        this.setState({ [`busy_${id}`]: false });
      }),
    );
  }

  renderPane(name, title, content) {
    return (
      <>
        <div className="d-flex w-100">
          <div
            className={cn(styles.accordionHeader, { [styles.openAccordionHeader]: this.state[name] })}
            onClick={this.setStateFn({ [name]: !this.state[name] })}
          >
            {title}
          </div>
          <div
            className={cn(styles.accordionIcon, { [styles.openAccordionIcon]: this.state[name] })}
            onClick={this.setStateFn({ [name]: !this.state[name] })}
          >
            {this.state[name] ? <IsClosed /> : <IsOpen />}{' '}
          </div>
        </div>
        {this.state[name] ? content : null}
      </>
    );
  }

  renderPhotoSection() {
    return (
      <div className="pane">
        <VBox className="hooi_instalation" key="hooi_instalation">
          {this.renderHooiInstalation()}

          {this.vehicle.documents
            ?.filter(document => document.type == 'vehicle_photos')
            .map(this.renderHooiInstalationPhoto.bind(this))}
        </VBox>
      </div>
    );
  }

  renderFormField(name, type) {
    let ISO;
    if (type == 'date') {
      let date = this.vehicle[name];
      try {
        ISO = date ? parseISO(dayjs(date, 'DD-MM-YYYY').format('YYYY-MM-DD')) : null;
        if (ISO == 'Invalid Date') ISO = null;
      } catch (error) {
        debugger;
      }
    }
    return (
      <FormField label={this.lbl('vehicle.property.' + name)} key={name}>
        <VehiclePropertyLoadable name={name}>
          {type == 'date' ? (
            <DatePicker
              dateFormat="dd-MM-yyyy"
              selected={this.vehicle[name] ? ISO : ''}
              onChange={val => {
                val = dayjs(val).format('DD-MM-YYYY');
                this.props.setProperty(name, val);
              }}
            />
          ) : (
            <Input
              type={type}
              value={this.state[name]}
              onChange={this.onInputChange.bind(this)}
              name={name}
              key={name}
              onBlur={() => {
                this.props.setProperty(name, this.state[name]);
              }}
            />
          )}
        </VehiclePropertyLoadable>
      </FormField>
    );
  }

  renderOption(value, index) {
    if (value.title)
      return (
        <div className="title" key={index}>
          {this.lbl(`vehicle.options.${value.title}`)}
        </div>
      );

    let option = this.props.allOptions?.find(o => o.name.toLowerCase() == value.toLowerCase());

    // if (!option) debugger;

    let vehicleHasOption = this.vehicle.options?.find(o => o.id == option?.id);

    let checked_name = `checked_${value}`;

    let checked = this.state[checked_name] || vehicleHasOption;
    let photo = this.vehicle.documents?.find(document => document.type == 'photo_hooi_' + value);

    let name = `vehicle-option-${option?.id}`;

    return (
      <HBox vCenter key={index} className={`option ${!option ? 'inactive' : ''} option-${option?.id}`}>
        <div>
          <VehiclePropertyLoadable name={name}>
            <CheckboxComponent
              label={value}
              checked={checked}
              onChange={option ? () => this.toggleOption(option.id, !checked) : null}
            />
          </VehiclePropertyLoadable>
        </div>
        <VehiclePropertyLoadable name={`upload_${value}`}>
          {photo ? (
            <div
              className={cn('pointer image-available', styles.buttonCamera)}
              onClick={() => {
                let container = document.getElementsByClassName('modal-inner')[0];
                let renderOptionPhotoDims = container.getBoundingClientRect();
                this.setState({
                  renderOptionPhoto: photo.id,
                  renderOptionPhotoDims,
                });
              }}
            >
              <Camera />
            </div>
          ) : (
            <div onClick={this.setStateFn({ optionPhoto: option?.id })} className={cn('pointer', styles.buttonCamera)}>
              <Camera
                onClick={() =>
                  this.capture(
                    value,
                    this.callback(() => this.props.toggleOption(option.id, true)),
                  )
                }
              />
            </div>
          )}
        </VehiclePropertyLoadable>
      </HBox>
    );
  }

  handlePhotoDelete = documentId => {
    if (confirm()) {
      const group = this.vehicle.documents?.find(d => d.id === documentId)?.type;
      if (this.vehicle.documents?.filter(d => d?.type === group)?.length === 1) {
        const index = group?.slice(25);
        this.setState({ [`hooi_instalation_comment_${index}`]: '' });
      }
      this.props.deleteDocument(documentId, this.setStateFn({ renderOptionPhoto: null }));
    }
  };

  renderOptionPhoto() {
    if (!this.state.renderOptionPhoto) return null;

    let document = this.vehicle.documents?.find(document => document.id == this.state.renderOptionPhoto);

    return (
      <div
        onClick={this.setStateFn({ renderOptionPhoto: null })}
        className="optionPhoto"
        style={{
          width: Math.ceil(this.state.renderOptionPhotoDims.width) + 'px',
          height: Math.ceil(this.state.renderOptionPhotoDims.height) + 'px',
          left: Math.ceil(this.state.renderOptionPhotoDims.x) + 'px',
          top: 0,
        }}
      >
        <div className="img" style={{ backgroundImage: `url('${document.url}')` }}></div>
        <HBox>
          <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.setStateFn({ renderOptionPhoto: null })}>
            <Left /> {this.lbl('back')}
          </ButtonComponent>

          <ButtonComponent style={'ButtonSoftDelete'} onClick={() => this.handlePhotoDelete(document.id)}>
            <Times />
            {this.lbl('delete')}
          </ButtonComponent>
        </HBox>
      </div>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent
        onClose={this.reset.bind(this)}
        title={
          <>
            {this.props.fullFetch ? (
              <>
                <Loader small />
                &nbsp;
              </>
            ) : null}
            {this.props.action.label}
          </>
        }
      >
        <WithVehicle loader vehicle_id={this.vehicle.id}>
          <div className="mb-2">
            <VehicleHeader vehicle={this.vehicle} hooikammer />
          </div>

          <Container>{this.renderModalBody()}</Container>
        </WithVehicle>
      </ModalComponent>
    );
  }

  renderTripleCheck(name) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 ? 2 : 0;

    return (
      <HBox vCenter key={name}>
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          // onClick={() => this.props.setProperty(name, state == 0 ? 1 : state == 1 ? 2 : 0)}
        >
          <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
          <VehiclePropertyLoadable name={name}>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`} // uniek per veld
                id={`btnradio1-${name}`}
                autoComplete="off"
                checked={state == 0}
                onChange={() => this.props.setProperty(name, 0)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio1-${name}`}>
                Todo
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio2-${name}`}
                autoComplete="off"
                checked={state == 1}
                onChange={() => this.props.setProperty(name, 1)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio2-${name}`}>
                Gereed
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio3-${name}`}
                autoComplete="off"
                checked={state == 2}
                onChange={() => this.props.setProperty(name, 2)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio3-${name}`}>
                Manco
              </label>
            </div>
          </VehiclePropertyLoadable>
        </div>
      </HBox>
    );
  }
  renderDoubleCheck(name) {
    let val = this.propertyValue(name);
    let state = val === undefined || val === 0 ? null : val == 1 ? 1 : 0;

    return (
      <HBox vCenter key={name}>
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          // onClick={() => this.props.setProperty(name, state == 0 ? 1 : 0)}
        >
          <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
          <VehiclePropertyLoadable name={name}>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`} // uniek per veld
                id={`btnradio1-${name}`}
                autoComplete="off"
                checked={state == 1}
                onChange={() => this.props.setProperty(name, 1)}
              />
              <label className={`btn btn-outline-primary ${state == 1 ? 'active' : ''}`} htmlFor={`btnradio1-${name}`}>
                Todo
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio2-${name}`}
                autoComplete="off"
                checked={state == 0}
                onChange={() => this.props.setProperty(name, 0)}
              />
              <label className={`btn btn-outline-primary ${state == 0 ? 'active' : ''}`} htmlFor={`btnradio2-${name}`}>
                Gereed
              </label>
            </div>
            {/*<div className="check">{state == 0 ? '-' : '+'}</div>*/}
          </VehiclePropertyLoadable>
        </div>
      </HBox>
    );
  }

  addHooiInstalationImage(index, isNewGroup = false) {
    this.capture('hooi_instalation_' + index);
  }

  renderHooiInstalationPhoto(document) {
    return (
      <div key={`hooi_instalation-${document.id}`}>
        <div
          className="hooi_instalation-img"
          onClick={() => {
            let container = window.document.getElementsByClassName('modal-inner')[0];
            let renderOptionPhotoDims = container.getBoundingClientRect();
            this.setState({
              renderOptionPhoto: document.id,
              renderOptionPhotoDims,
            });
          }}
          style={{ backgroundImage: `url('${document.url}')` }}
        ></div>
      </div>
    );
  }

  renderModalBody() {
    return (
      <>
        <VBox key="body">
          {this.renderOptionPhoto()}
          {this.renderPane(
            'Voertuiggegevens',
            this.lbl('interior.inspection.vehicledata'),
            <VBox className="manco-list" key="manco">
              <Row>
                <Cell>{this.lbl(`vehicle.property.creditor_company`)}</Cell>
                <Cell>
                  <CompanyLabelById company_id={this.vehicle.creditor_company} />
                </Cell>
              </Row>
              <div>
                {this.lbl('vehicle.property.num_keys')}
                <HBox left>
                  <VehiclePropertyLoadable name="num_keys">
                    <div className={styles.containerButtonBar}>
                      <ButtonBar>
                        {_.times(6, num => {
                          num += 0;
                          return (
                            <Button
                              className={styles.buttonBarItem}
                              key={num}
                              small
                              disabled={this.props.work}
                              primary={num == this.propertyValue('num_keys')}
                              onClick={() => {
                                this.props.setProperty('num_keys', num);
                              }}
                            >
                              {num}
                            </Button>
                          );
                        })}
                      </ButtonBar>
                    </div>

                    <ButtonBar></ButtonBar>
                  </VehiclePropertyLoadable>
                </HBox>
              </div>

              <Row>
                <Cell>
                  <div className={styles.editableInputContainer}>
                    <VehiclePropertyEditableInput
                      classNameInput={styles.editableInput}
                      className={styles.editableInputButton}
                      propertyName="mileage"
                      vehicle_id={this.vehicle.id}
                    />
                  </div>
                </Cell>
              </Row>
            </VBox>,
          )}
          {/* {this.renderPhotoSection()} */}

          {this.renderPane(
            'Proces',
            this.lbl('interior.inspection.proces'),
            <VBox className="manco-list" key="manco">
              <Row>
                <Cell>
                  {[
                    'HOOI_hemex_proces',
                    'HOOI_hooikammer_proces',
                    'HOOI_check_auto',
                    'HOOI_stalling',
                    'HOOI_no_keys',
                    'HOOI_niet_schoonmaken',
                  ].map(name => this.renderDoubleCheck(name))}
                </Cell>
              </Row>
              {/* <Row></Row> */}
              <Row>
                <Cell>
                  {['HOOI_rijdbaar', 'HOOI_rijdbaar_slechte_accu', 'HOOI_rolbaar', 'HOOI_niet_rolbaar'].map(name =>
                    this.renderDoubleCheck(name),
                  )}
                </Cell>
              </Row>
            </VBox>,
          )}
          {this.renderPane(
            'Check auto',
            this.lbl('interior.inspection.check_auto'),
            <VBox className="manco-list" key="manco">
              <Row>
                <Cell>
                  {['HOOI_task_extreme_cleaning', 'HOOI_task_desticker', 'HOOI_task_polish_exterior'].map(name =>
                    this.renderDoubleCheck(name),
                  )}
                </Cell>
              </Row>
              {/* <Row></Row> */}
            </VBox>,
          )}
        </VBox>
        <VehiclePropertyLoadable className="text-center" name="label_printer_queue">
          <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.props.print}>
            Print label
          </ButtonComponent>
        </VehiclePropertyLoadable>

        <div className="d-flex gap-2 mt-3">
          <PerformActionButton
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </>
    );
  }

  render() {
    const vehicle = this.vehicle;

    if (!vehicle || !this.props.allOptions) return <Loader small />;

    return (
      <ActionCell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} hooikammer />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <div className={styles.cellButtonContainer}>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </div>
            )}
          </CellButtons>
          {this.renderApprove()}
        </Container>
      </ActionCell>
    );
  }

  onCommentChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  renderHooiInstalation() {
    const v = this.props.vehicle;

    if (!v) return null;

    let rows = [];

    let photos = v.documents?.filter(d => {
      return d.type?.indexOf(`photo_hooi_hooi_instalation`) === 0;
    });

    if (photos?.length) {
      rows.push({
        index: 0,
        photos,
      });
    }

    const index = rows.map(row => row?.photos?.length)[0] || 0;

    return (
      <VBox className="align-items-center" key="hooi_instalations">
        {rows.map(row => (
          <VBox center>
            <HBox flexWrap left key={`hooi_instalation-row-${row.index}`} style={{ maxWidth: '400px' }}>
              {row.photos.map(d => this.renderHooiInstalationPhoto(d))}
            </HBox>
            <HBox></HBox>
          </VBox>
        ))}
        <ButtonComponent
          style={'ButtonSoftPrimary'}
          onClick={() => this.addHooiInstalationImage(index ? index + 1 : 0, true)}
        >
          <Plus />
          {this.lbl('add')}
        </ButtonComponent>
      </VBox>
    );
    return null;
  }
}

HOOI_inslagComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    allOptions: selectAllOptions(),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    toggleOption(optionId, state, callback) {
      let fn = state ? addVehicleOption : removeVehicleOption;
      dispatch(fn(ownProps.cell.vehicle.id, optionId, callback));
    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
    imageUpload(documentDto, work, callback) {
      dispatch(addDocument(ownProps.cell.vehicle.id, 'vehicle', documentDto, callback, work));
    },
    deleteDocument(id, callback) {
      dispatch(deleteDocument(ownProps.cell.vehicle.id, 'vehicle', id, callback));
    },
    deleteProperty(name) {
      dispatch(deleteVehicleProperty(ownProps.cell.vehicle.id, name));
    },
    print() {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, 'label_printer_queue', '1'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_inslag = compose(withConnect, withRouter)(HOOI_inslagComp);
